import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import PropTypes from 'prop-types';
import {
  LOGIN_ROUTE,
  PUBLIC_SPACE_LANDING_PAGE_ROUTE,
} from '../../services/routes';
import { spaceIDFromAppUrl } from '../../services/spaces';
import { currentUserSelector } from '../../features/user_id/user_id_slice';
import { useGetEndUserSpaceQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const RequireAuth = ({ children, returnHere }) => {
  const intoSpaceID = spaceIDFromAppUrl();

  const { data: currentEndUserSpace } = useGetEndUserSpaceQuery();

  const spaceIDOverride = useSelector(
    (state) => state.whiteLabel.endUserDesiredSpaceID,
  );

  const actualSpaceID =
    intoSpaceID || spaceIDOverride || currentEndUserSpace?.id;

  const redirectTo = actualSpaceID
    ? formatRoute(PUBLIC_SPACE_LANDING_PAGE_ROUTE, { spaceId: actualSpaceID })
    : LOGIN_ROUTE;

  const { username, isLoading: isUsernameLoading } =
    useSelector(currentUserSelector);
  const isLoggedIn = !!username;

  if (isLoggedIn) {
    console.log(`RequireAuth: user logged in`);
    return children;
  }

  if (isUsernameLoading) {
    console.log(`RequireAuth: Current username is loading`);
    // If the username is still loading, we don't want to redirect yet.
    return null;
  }

  console.log(
    `RequireAuth: User is not logged in, redirecting to ${redirectTo}`,
  );

  console.log({
    intoSpaceID,
    spaceIDOverride,
    currentEndUserSpaceID: currentEndUserSpace?.id,
  });

  let queryString = '';
  if (returnHere) {
    queryString = `?${new URLSearchParams({
      returnTo: window.location.href,
    })}`;
  }
  return <Navigate to={`${redirectTo}${queryString}`} replace />;
};

RequireAuth.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  returnHere: PropTypes.bool,
};

RequireAuth.defaultProps = {
  returnHere: false,
};

export default RequireAuth;
